import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { ArticleCard } from '~components/ArticleCard/ArticleCard';
import { Section } from '~components/Section/Section';
import { ArticleCardImagePosition } from '~types/Article.types';

import styles from './ArticlePageRecommend.module.scss';
import { ArticlePageRecommendProps } from './ArticlePageRecommend.types';

export function ArticlePageRecommend({
  cards,
  title = 'Почитать по теме',
}: ArticlePageRecommendProps) {
  if (!cards?.length) return null;

  return (
    <Section>
      <Typography tagName={TypographySizes.h4} mods={[TypographyMods.titleL]}>
        {title}
      </Typography>
      <div className={styles.cards}>
        <div className={styles.cardsInner}>
          {cards.map((card, idx) => (
            <ArticleCard
              key={card.id}
              className={styles.card}
              imagePosition={
                idx === 1
                  ? ArticleCardImagePosition.Bottom
                  : ArticleCardImagePosition.Top
              }
              {...card}
            />
          ))}
        </div>
      </div>
    </Section>
  );
}
